import { cn } from '@/lib/utils';
import type { ArtifactCategory } from '@/config/objects/artifacts';

interface ArtifactCategoryBadgeProps {
  category: ArtifactCategory;
  className?: string;
  /** Use 'solid' variant for dark backgrounds */
  variant?: 'default' | 'solid';
}

const categoryConfig: Record<ArtifactCategory, { label: string; default: string; solid: string }> = {
  offensive: {
    label: 'Offensive',
    default: 'bg-red-100 text-red-700',
    solid: 'bg-red-500 text-white',
  },
  defensive: {
    label: 'Defensive',
    default: 'bg-blue-100 text-blue-700',
    solid: 'bg-blue-500 text-white',
  },
  wildcard: {
    label: 'Wildcard',
    default: 'bg-purple-100 text-purple-700',
    solid: 'bg-purple-500 text-white',
  },
};

export function ArtifactCategoryBadge({ category, className, variant = 'default' }: ArtifactCategoryBadgeProps) {
  const config = categoryConfig[category];
  if (!config) return null;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        config[variant],
        className,
      )}
    >
      {config.label}
    </span>
  );
}
